import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetSpecificProductSaleReportApi } from "./Report.action";
import { Link } from "react-router-dom";
import { CalendarIcon, DownloadIcon, ChevronRightIcon } from "../../../components/Icons";
import { getProductData } from "../AddProduct/Product.action";
import _ from "lodash";
import Swal from "sweetalert";
import moment from "moment";
import SinglePageDashboard from "../../../drawer/SinglePageDashbord";
import GlobalFormCard from "../../../components/GlobalFormCard";
import SelectorField from "../../../components/SelectorField";
import DateField from "../../../components/DateField";
import "./Report.css";


const SpecificProductSaleReport = (props) => {
    const [startDate, setStartDate] = useState(moment().startOf('month').format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [product, setProduct] = useState("");
    const [productName, setProductName] = useState("");
    const isDisabled = _.isEmpty(startDate) || _.isEmpty(endDate) || _.isEmpty(product) || props.isFetchingSpecificProductReport;

    const handleDangerVisible = () => {
        Swal({
            title: "Error",
            text: "Something went wrong!",
            icon: "error",
            button: "Ok",
        });
    };

    const GenratePDF = () => {
        props.GetSpecificProductSaleReportApi({
            startDate: startDate,
            endDate: endDate,
            product: product,
            productName: productName,
        },
            handleDangerVisible,
        );
    };

    const handleChangeProduct = (selectedOption) => {
        if (!selectedOption) {
            setProduct("");
            setProductName("");
            return;
        }
        setProduct(selectedOption.value);
        setProductName(selectedOption.label);
    };
    const productList = _.isEmpty(props.productDataList) ? [] : props.productDataList.map((x) => {
        let data = {
            value: x._id,
            label: x.name,
        };
        return data;
    });


    useEffect(() => {
        props.getProductData();
    }, []);

    return (
        <>
            <SinglePageDashboard header="Specific Product Sale Report" />

            <div className="page-container">
                <div className="breadcrumb">
                    <Link to="/home" className="breadcrumb-link">Home</Link>
                    <ChevronRightIcon />
                    <Link to="/report" className="breadcrumb-link">Reports</Link>
                    <ChevronRightIcon />
                    <span className="breadcrumb-current">Specific Product Sale Report</span>
                </div>

                <div className="page-header">
                    <h1 className="page-title">Specific Product Sale Report</h1>
                </div>

                <GlobalFormCard
                    title="Select Date"
                    subtitle="Report will be generated for this date"
                    icon={<CalendarIcon />}
                    maxWidth="900px"
                >
                    <DateField
                        label='Start Date'
                        value={startDate}
                        onChange={setStartDate}
                    />

                    <DateField
                        label='End Date'
                        value={endDate}
                        onChange={setEndDate}
                    />

                    <SelectorField
                        options={productList}
                        value={product}
                        onChange={handleChangeProduct}
                        isDisabled={false}
                        isLoading={props.isFetchingProduct}
                        label="Select Product"
                    />

                    <div className="divider" />

                    <button
                        onClick={GenratePDF}
                        disabled={isDisabled}
                        className={`generate-btn ${isDisabled ? "disabled" : ""}`}
                    >
                        {props.isFetchingSpecificProductReport ? (
                            <>
                                <span className="spinner" />
                                Generating…
                            </>
                        ) : (
                            <>
                                <DownloadIcon />
                                Generate Report
                            </>
                        )}
                    </button>

                    <p className="footer-text">Report will be downloaded as a PDF file</p>

                </GlobalFormCard>
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    GetSpecificProductSaleReportApi: (payload, handleDangerVisible) => dispatch(GetSpecificProductSaleReportApi(payload, handleDangerVisible)),
    getProductData: () => dispatch(getProductData()),
});

const mapStateToProps = (state) => ({
    isFetchingSpecificProductReport: state.ReportReducer.isFetchingSpecificProductReport,
    specificProductSaleReportData: state.ReportReducer.specificProductSaleReportData,
    isFetchingProduct: state.ProductReducer.isFetchingProduct,
    productDataList: state.ProductReducer.productDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(SpecificProductSaleReport);